<template>
<div class="chapter">
<div class="inner_page">
<p class="p2"><span class="sz"> </span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p4"><span class="sz">This book is dedicated to the original crew of the U.S.S. <i>Repuls(iv)e</i></span></p>
<p class="p5"><span class="sz"> </span></p>
<p class="p4"><span class="sz">Aleta Akhtar,</span></p>
<p class="p4"><span class="sz">Barb Carlson,</span></p>
<p class="p4"><span class="sz">Bill Hohmann,</span></p>
<p class="p4"><span class="sz">Tom Howell,</span></p>
<p class="p4"><span class="sz">Nancy Janda,</span></p>
<p class="p4"><span class="sz">Dave Jordan,</span></p>
<p class="p4"><span class="sz">Judy Laub,</span></p>
<p class="p4"><span class="sz">Patrick Place,</span></p>
<p class="p4"><span class="sz">Gordon Rose</span></p>
<p class="p6"><span class="sz"> </span></p>
<p class="p6"><span class="sz"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?bb1a33d0